//import React from 'react'

import {useParams} from 'react-router-dom'

import React, { useState } from 'react';

import {AddressesWithCustprofile} from '../containers'

function AddressesWithCustprofilePage() {
    console.log('MON23SV******************AddressesWithCustprofilePage')
    let { id } = useParams();
    if(!id){
        id = 8
    }
    console.log('MON23SV****************id', id)
    let svparams = { 'id': id}
    return (
        <AddressesWithCustprofile svparams= {svparams} />
    );
}
export default AddressesWithCustprofilePage


